module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-A"
  }, [_vm._v("Foreword")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("When you stop to think about the bounty of food that God provided on this earth for us to experience, it is truly amazing. The incredible array of tastes, colors, textures, and scents tells me that food is meant to be enjoyed and celebrated. And there is no better way to enjoy God’s abundance than to share a meal together with people you love. From the beginning of time, there have been few things that knit us more closely together as humans than to sit down and share a meal. In fact, numerous studies have shown that the more regularly families eat together, the healthier, happier, and better off they are.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal1"
  }, [_vm._v("Some of my most treasured memories as a child were those times we shared eating together as a family. I can remember the wonderful aromas coming from the kitchen when my mother and father were cooking. Years later, I can still appreciate how coming together regularly over dinner allowed our family to stay informed about one another’s daily lives, to talk about our dreams and aspirations, and to just be together.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal1"
  }, [_vm._v("Joel and I continue that tradition today with our family. On Sunday evenings and on special occasions, it is not unusual for lots of people to gather at our house; parents, brothers, sisters, nieces, nephews, and friends. Of course, there is always lots of food. I believe this is the way God intended food to be enjoyed—together with those you love.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal1",
    attrs: {
      "id": "a85"
    }
  }, [_vm._v("At Lakewood, we teach about taking time to invest in our families and our relationships. That’s why I am so glad that Diane decided to write this beautiful book about the tradition of Sunday dinner. I encourage you to share this book with your family. If you don’t have a tradition of having meals together, why not start now by setting aside one day a week to sit down to dinner together? Try the recipes in this book, and make it a time to give thanks for your family, friends, and the bounty of food that God provided.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right",
      "font-size": "150%",
      "margin-top": "1.5em"
    }
  }, [_c('span', {
    staticClass: "Pointed-Brush"
  }, [_vm._v("Victoria Osteen")])]), _vm._v(" "), _c('p', {
    staticClass: "p-content1",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("LAKEWOOD CHURCH, CO-PASTOR")]), _vm._v(" "), _c('div', {
    staticClass: "illustration1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img3.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eaf5090","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/foreword.vue
// module id = 69
// module chunks = 0